import DayGridScenario from '../schema/DayGridScenario';
import { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';

export const initializeDayView = action(
    'initializeDayView',
    (scenario: DayGridScenario, initialDate: OwaDate, focusTime?: OwaDate) => ({
        scenario,
        initialDate,
        focusTime,
    })
);

export const resetDayGridScenario = action('resetDayGridScenario', (scenario: DayGridScenario) => ({
    scenario,
}));

export const selectDayGridDate = action(
    'selectDayGridDate',
    (scenario: DayGridScenario, newDate: OwaDate) => ({
        scenario,
        newDate,
    })
);
